import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import socket from "../../assets/socketConnection";
import CheckoutList from "../../containers/checkoutList/checkoutList.container";
import TransactionList from "../../containers/transactionList/transactionList.container";
// import ToggleTabs from "../../containerSmall/toggleTabs/toggleTabs.component";
import ToggleTabs from "../../containerSmall/toggleTabs/toggleTabs.component";
import {
  setCreditTab,
  fetchAccountDeatailAsync,
} from "../../redux/credit/credit.actions";
import {
  selectCreditAccountDetailIsLoading,
  selectCreditActiveTab,
  selectCreditTransactions,
} from "../../redux/credit/credit.selectors";
import { selectUserInfo } from "../../redux/user/user.selectors";
import WithSpinner from "../../HOC/withSpinner/WithSpinner.component";
import { WhiteBtn } from "./wallet.styles";
import ModalWallet from "../../components/modalWallet/modalWallet.component";
import ModalWalletCheckOut from "../../components/modalWalletCheckOut/modalWalletCheckOut.component";
const TransactionListWithSpinner = WithSpinner(TransactionList);
const CheckoutListWithSpinner = WithSpinner(CheckoutList);
const Wallet = ({
  setCreditTab,
  selectCreditActiveTab,
  selectUserInfo,
  fetchAccountDeatailAsync,
  selectCreditTransactions,
  selectCreditAccountDetailIsLoading,
}) => {
  const [visible, setVisible] = useState(false);
  const [visibleCO, setVisibleCO] = useState(false);
  const [bankInfo, setBankInfo] = useState();
  const [checkoutList, setCheckoutList] = useState();
  useEffect(() => {
    fetchAccountDeatailAsync(socket);
  }, []);

  useEffect(() => {
    socket.emit("get_bank_info", {});
    console.log("bijan");
    socket.on("response_bank_info", (info) => {
      setBankInfo(info);
    });
  }, []);

  useEffect(() => {
    socket.emit("get_my_withdrawals", {});
    socket.on("response_my_withdrawals", (info) => {
      setCheckoutList(info);
    });
  }, []);
  const showModal = () => {
    setVisible(true);
  };
  const showModalCO = () => {
    setVisibleCO(true);
    // console.log(bankInfo[0].to_bank.sheba);
  };

  // const Messages=()=>{
  //   socket.emit("get_my_messages",{})
  //   socket.on("response_my_messages",(messages)=>
  //   console.log(messages))
  // }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <ToggleTabs
          style={{ width: "45%" }}
          getTab={selectCreditActiveTab}
          setTab={setCreditTab}
        >
          <button data-n={0}>تراکنش‌ها</button>
          <button data-n={1}>تسویه‌حساب‌ها</button>
        </ToggleTabs>
        <div style={{ marginLeft: "10%" }}>
          {/* <button onClick={Messages}>LOG</button> */}
          <WhiteBtn onClick={showModal}>افزایش اعتبار</WhiteBtn>
          <WhiteBtn onClick={showModalCO} className="mr-3">
            {/* ()=>console.log(bankInfo) */}
            تسویه حساب
          </WhiteBtn>
        </div>
      </div>
      <div className="h-100 py-4">
        <ModalWallet
          visible={visible}
          setVisible={setVisible}
          selectUserInfo={selectUserInfo._id}
        />
        <ModalWalletCheckOut
          socket={socket}
          bankInfo={bankInfo}
          visible={visibleCO}
          setVisible={setVisibleCO}
        />
        {Number(selectCreditActiveTab) === 0 ? (
          <TransactionListWithSpinner
            isLoading={selectCreditAccountDetailIsLoading}
            transList={selectCreditTransactions}
          />
        ) : (
          <CheckoutListWithSpinner checkoutList={checkoutList} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectCreditActiveTab: selectCreditActiveTab,
  selectCreditTransactions: selectCreditTransactions,
  selectCreditAccountDetailIsLoading: selectCreditAccountDetailIsLoading,
  selectUserInfo: selectUserInfo,
});
const mapDispatchToProps = (dispatch) => ({
  setCreditTab: (tab) => dispatch(setCreditTab(tab)),
  fetchAccountDeatailAsync: (x) => dispatch(fetchAccountDeatailAsync(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wallet);
